
import _ from './ext/lodash'
import packageConfig from '../../package'
import localizationStrings from "./localization.js"
import {
  normalizeQueryWithPunctuation,
  clearemptystrings,
  weakRanks,
  usableLocalStorage,
	scaledWeight,
} from "./util.js"
import SettingsPage from "./views/pages/settings-page"
import InfoPage from "./views/pages/info-page"
import CategoriesPage from "./views/pages/categories-page"
import AccountPage from "./views/pages/account-page"
import AccountButton from "./views/account-button"
import {buildClassList} from "./utils/helpers";
import {hymn_search} from "./utils/search";
import HymnParser from './model/hymnParser'
import { THEME_COLORS } from './model/colors';
import {HymnListOld} from "./views/hymn-list";
import CenteredDiv from './views/centered-div'

// --------------- //
// ---- React ---- //
// --------------- //

export default class HymnAppView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pages: {
        home: true,
        settings: false,
        info: false,
        categories: false,
        list: false,
        search: false,
        hymn: false,
        account: false,
      },
      activeGroup: 'recents',
      hymn: 1,
      activeSnackbarCalls: 0,
      totalSnackbarCalls: 0,
    };
    this.hymnalChoices = Object.keys(this.props.hymnal).map(key =>
      [key, this.props.hymnal[key].year + ' ' +
      localizationStrings[this.props.hymnal[key].languageCode].words[this.props.hymnal[key].languageCode]]);

  }

  componentDidMount() { // TODO implement proper keyboard shortcuts
    $(window).keydown(event => {
      if(event.key !== 'Escape') return;
      const [pageKey] = _.findLast(_.toPairs(this.state.pages), 1);
      const pages = _.assign({}, this.state.pages, {[pageKey]: false});
      if(pageKey !== 'home') this.setState({ pages });
    })
  }

  componentWillUnmount() {
    $(window).off('keypress')
  }

  showPage(page) {

    // search
    setTimeout(()=>{
      if(page === 'search') {
        $('#search-page .search-bar-input').focus().select();
      } else if(page === 'hymn') {
        $('#search-page .search-bar-input').blur();
      }
    }, 500);

    const pages = this.state.pages;
    pages[page] = true;
    this.setState({ pages });
  }

  hidePage(page) {

    // search
    setTimeout(()=>{
      if(page === 'search') {
        $('#search-page .search-bar-input').blur();
      } else if(page === 'hymn') {
        if(this.state.pages.search) {
          $('#search-page .search-bar-input').focus().select();
        }
      }
    }, 500);

    const pages = this.state.pages;
    pages[page] = false;
    this.setState({ pages });
  }

  showList(group) {
    this.setState({ activeGroup: group });
    this.showPage('list');
  }

  openHymn(hymn) {
    this.props.actions.recent(hymn);
    this.setState({ hymn });
    this.showPage('hymn');
  }

  setTheme(theme) {
    // set in doc css
    const [base, accent] = theme;
    document.documentElement.style.setProperty('--primary-color', THEME_COLORS[base].base);
    document.documentElement.style.setProperty('--secondary-color', THEME_COLORS[base].secondary);
    document.documentElement.style.setProperty('--accent-color', THEME_COLORS[base].accents[accent]);

  }

  processFavorite() {
    if(!this.props.user.name) {
      this.incTotalSnackCount();
      if((Math.random() * this.state.totalSnackbarCalls) < 2) {
        this.incSnackCount();
        setTimeout(() => this.decSnackCount(), 4000);
      }
    }
  }

  incTotalSnackCount() {
    this.setState({totalSnackbarCalls: this.state.totalSnackbarCalls + 1});
  }

  incSnackCount() {
    this.setState({activeSnackbarCalls: this.state.activeSnackbarCalls + 1});
  }

  decSnackCount() {
    this.setState({activeSnackbarCalls: this.state.activeSnackbarCalls - 1});
  }

  logout() {
    if(window.prompt('Logout?')) {
      this.props.actions.logout()
    }
  }

  render() {


    const user = this.props.user;
    const hymnal = this.props.hymnal[user.hymnal];

    const language = user.language || hymnal.languageCode;
    const languageStrings = localizationStrings[language];
    this.setTheme(this.props.user.theme);

    const popular = this.props.popular[user.hymnal] || [];
    const crudeUsageLogs = this.props.hymnUsageLogs[user.hymnal] || [];
    const usageLogs = _.map(_.toPairs(crudeUsageLogs), ([n, t]) => [n, scaledWeight(t)] );

    let list = [];
    switch(this.state.activeGroup) {
      case 'favorites':
        list = user.favorites;
        break;
      case 'recents':
        list = user.recents;
        break;
      case 'popular':
        list = popular;
        break;
    }

    // snackbar
    let showSnackbar = !!this.state.activeSnackbarCalls;

    return (
      <div id="hymn-app">

        <HymnAppHomePage
          show={this.state.pages.home}
          title={languageStrings.words.hymnal}
          user={user}
          hymnalChoices={this.hymnalChoices}
          hymnal={hymnal}
          popular={popular}
          openHymn={n => this.openHymn(n)}
          onFavorite={n => { this.props.actions.favorite(n); this.processFavorite() }}
          onHymnal={h => this.props.actions.setHymnal(h)}
          languageStrings={languageStrings}
          showList={page => this.showList(page)}
          showPage={page => this.showPage(page)} />

        <SettingsPage
          show={this.state.pages.settings}
          languageStrings={languageStrings}
          theme={user.theme}
          allHymnals={this.props.hymnal}
          setTheme={a => this.props.actions.setTheme(a)} // <<
          setLanguage={l => this.props.actions.setLanguage(l)}
          hidePage={() => this.hidePage('settings')} />

        <InfoPage
          show={this.state.pages.info}
          languageStrings={languageStrings}
          hidePage={() => this.hidePage('info')} />

        <CategoriesPage
          show={this.state.pages.categories}
          title={languageStrings.words.categories}
          hymnal={hymnal}
          hymns={hymnal.data}
          user={user}
          openHymn={n => this.openHymn(n)}
          onFavorite={n => { this.props.actions.favorite(n); this.processFavorite() }}
          hidePage={() => this.hidePage('categories')} />

        <HymnAppListPage
          show={this.state.pages.list}
          title={languageStrings.words[this.state.activeGroup]}
          list={list}
          hymns={hymnal.data}
          usageLogs={usageLogs}
          user={user}
          openHymn={n => this.openHymn(n)}
          onFavorite={n => { this.props.actions.favorite(n); this.processFavorite() }}
          languageStrings={languageStrings}
          hidePage={() => this.hidePage('list')} />

        <HymnAppSearchPage
          show={this.state.pages.search}
          hymns={hymnal.data}
					usageLogs={usageLogs}
          favorites={user.favorites}
          openHymn={n => this.openHymn(n)}
          onFavorite={n => { this.props.actions.favorite(n); this.processFavorite() }}
          languageStrings={languageStrings}
          hidePage={() => this.hidePage('search')} />

        <HymnAppHymnPage
          show={this.state.pages.hymn}
          hymn={this.state.hymn}
          hymns={hymnal.data}
          favorites={user.favorites}
          onFavorite={n => { this.props.actions.favorite(n); this.processFavorite() }}
          languageStrings={languageStrings}
          hidePage={() => this.hidePage('hymn')} />

        <AccountPage
          show={this.state.pages.account}
          title={languageStrings.words.account}
          user={user}
          signIn={p => this.props.actions.signIn(p)}
          link={p => this.props.actions.link(p)}
          unlink={pid => this.props.actions.unlink(pid)}
          logout={() => this.props.actions.logout()}
          languageStrings={languageStrings}
          hidePage={() => this.hidePage('account')} />

        <Snackbar
          showing={showSnackbar}
          message={languageStrings.phrases.signInForFavorites}
          linkMessage={languageStrings.words.signIn}
          linkAction={() => this.showPage('account')} />

      </div>
    );

  }

}

function sleep(milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if ((new Date().getTime() - start) > milliseconds){
      break;
    }
  }
}

class HymnAppHomePage extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    $('#fab').on('click', ()=>{
      $('#search-page').removeClass('hidden');
      $('#search-page .search-bar-input').focus();
    })
  }

  componentWillUnmount() {
    $('#fab').off('click');
  }

  render() {

    let pageClass = 'app-page';
    if(!this.props.show) pageClass += ' hidden';

    const hymnal = this.props.hymnal;
    const hymns = hymnal.data;

    const favoritesShow = !!this.props.user.favorites.length;
    const recentsShow = !!this.props.user.recents.length;
    const popularShow = !!this.props.popular.length;

    // const popularSectionLength = (!recentsShow && !favoritesShow) ? 7 : 3 ;

    const accountButtonAction = () => this.props.showPage('account');
    // const accountButtonAction = this.props.user.name ? (() => (window.confirm(this.props.languageStrings.phrases.logout) && this.props.logout())) : () => this.props.showPage('account');

    const hymnalChoices = this.props.hymnalChoices.map(([value, text]) => <option key={value} value={value}>{text}</option>);
    // const hymnalChoices = this.props.hymnalChoices.map(text => <option>{text}</option>);

    const classes = {
      hr: buildClassList('home-section', {'hide': !recentsShow}),
      recentsContainer: buildClassList('home-section', {'hide': !recentsShow}),
    };

    return (
      <div id="home-page" className={pageClass}>
        <div className="page-content">

          <div className="page-header">
            <div className="icon-tray-left">
              <MaterialIcon className="clickable" code="info" onClick={() => this.props.showPage('info')} />
              <span className='version-tag'>v{packageConfig.version}-beta</span>
            </div>
            <div className="icon-tray float--right">
              <AccountButton
                user={this.props.user}
                onClick={accountButtonAction}/>
              <MaterialIcon className="clickable" code="settings" onClick={() => this.props.showPage('settings')} />
            </div>
            <div className="home-header text--center width--full">
							<span className="page-title width--full">
                {sdaLogoSvg}
                {this.props.title}</span>
              <span className="page-subtitle width--full">
                <select className="clickable" value={this.props.user.hymnal} onChange={e => this.props.onHymnal(e.target.value)}>
                  {hymnalChoices}
                </select> ▾
              </span>
            </div>
            <div className="margin-bottom--32 text--center width--full">
              <div className="named-icon-button clickable" onClick={() => this.props.showList('favorites')}>
                <MaterialIcon code="favorite" />
                <span>{this.props.languageStrings.words.favorites}</span>
              </div>
              <div className="named-icon-button clickable" onClick={() => this.props.showList('popular')}>
                <MaterialIcon code="trending_up" />
                <span>{this.props.languageStrings.words.popular}</span>
              </div>
              <div className="named-icon-button clickable" onClick={() => this.props.showPage('categories')}>
                <MaterialIcon code="collections_bookmark" />
                <span>{this.props.languageStrings.words.categories}</span>
              </div>
            </div>
          </div>

          <div className="page-bottom">

            <hr className={classes.hr} />

            <div className={classes.recentsContainer}> { /* TODO -- fix! inefficient */ }
              <span
                className="home-section-title width--full clickable"
                onClick={() => this.props.showList('recents')}>
                {this.props.languageStrings.words.recents}
                <MaterialIcon className="float--right margin-top--4" code="keyboard_arrow_right"/>
              </span>
              <HymnListOld
                hymns={hymns}
                list={this.props.user.recents.slice(-20)}
                favorites={this.props.user.favorites}
                recents={this.props.user.recents}
                sortMethod="Latest Viewed"
                onClick={n => this.props.openHymn(n)}
                onFavorite={n => this.props.onFavorite(n)} />
            </div>
          </div>

          <div id="fab" onClick={() => this.props.showPage('search')}>
            <MaterialIcon code="search" />
          </div>

        </div>
      </div>
    );
  }
}

class HymnAppListPage extends React.Component {

  constructor(props) {
    super(props);
    this.defaultState = {
      showSearch: false,
      showSort: false,
      sortMethod: 'Latest Viewed',
      query: '',
      queriedList: [],
    };
    this.state = this.defaultState;
    this.sortMethodOptions = [
      'Latest Viewed',
      'Oldest Viewed',
      'Alphabetically',
      'Reverse Alphabetically',
      'by Favorites',
      'by Number Ascending',
      'by Number Descending',
    ]
  }

  componentDidMount() {
    $('#list-page i[code="search"]').on('click', ()=>{
      $('#list-page .page-header.hidden').removeClass('hidden');
      $('#list-page .search-bar-input').focus().select();
    })
  }

  componentWillUnmount() {
    $('#list-page i[code="search"]').off('click');
  }

  updateSortMethod(method) {
    this.setState({
      sortMethod: method,
    })
  }

  toggleState(prop) {
    this.setState({
      [prop]: !this.state[prop]
    })
  }

  closePage() {
    this.resetState();
    this.props.hidePage()
  }

  resetState() {
    this.setState(this.defaultState)
  }

  updateSearchQuery(query) {
    const hymnObjectList = _.map(this.props.list, n => this.props.hymns[n-1]); // BAD BAD why list is numbers??
    const list = _.map(hymn_search(hymnObjectList, query, this.props.usageLogs), '1.number');
    this.setState({query, queriedList: list})
  }

  openSearch() {
    this.setState({
      showSearch: true,
      showSort: false
    });
  }

  closeSearch() {
    this.setState({
      query: '',
      queriedList: [],
      showSearch: false
    })
  }

  openHymn(n) {
    this.closeSearch();
    this.props.openHymn(n);
  }

  render() {
    const queriedListEmpty = this.state.queriedList.length === 0;
    const list = queriedListEmpty ? this.props.list : this.state.queriedList;

    const listEmpty = !list.length;
    const classes = {
      page: buildClassList('app-page', {'hidden': !this.props.show}),
      titleHeader: buildClassList('page-header', {'hidden': this.state.showSearch}),
      searchHeader: buildClassList('page-header', {'hidden': !this.state.showSearch}),
      subtitleBar: buildClassList('subtitle-bar', {'hidden': !this.state.showSort}),
      sortButton: buildClassList('clickable', {'disabled': listEmpty}),
      searchButton: buildClassList('clickable', {'disabled': listEmpty}),
    };

    return (

      <div id="list-page" className={classes.page}>
        <div className="page-content">
          <div className={classes.titleHeader}>
            <span className="page-title">{this.props.title}</span>
            <span className="right-title icon-tray">
                <MaterialIcon code="search" className={classes.searchButton} onClick={() => !listEmpty && this.openSearch() } />
                <MaterialIcon code="sort" className={classes.sortButton} onClick={() => !listEmpty && this.toggleState('showSort')} />
                <CloseButton onClick={() => this.closePage()} />
              </span>
          </div>
          <div className={classes.searchHeader}>
            <SearchBar query={this.state.query} onChange={q => this.updateSearchQuery(q)} placeholder={this.props.languageStrings.phrases.search(this.props.title)} />
            <span className="right-title icon-tray">
              <CloseButton onClick={() => this.closeSearch() } />
            </span>
          </div>
          <div className="page-bottom">

            <span className={classes.subtitleBar}>
              <ListSort options={this.sortMethodOptions} onChange={method => this.updateSortMethod(method)} languageStrings={this.props.languageStrings} />
            </span>
            <HymnListOld
              hymns={this.props.hymns}
              list={list}
              favorites={this.props.user.favorites}
              recents={this.props.user.recents}
              sortMethod={this.state.sortMethod}
              onClick={n => this.openHymn(n)}
              onFavorite={n => this.props.onFavorite(n)} />

          </div>
        </div>
      </div>

    );
  }
}

class HymnAppSearchPage extends React.Component {

  // TODO: support for keyboard interaction

  constructor(props) {
    super(props);
    this.state = {
      query: '',
      list: [],
    };
  }

  updateSearchQuery(query) {
    const list = _.map(hymn_search(this.props.hymns, query, this.props.usageLogs), '1.number');

    this.setState({ query, list })
  }

  search(hymnal, query) {

    let ranks = [];
    for(let i = 0; i < hymnal.length; i++) {
      ranks.push({hymn: hymnal[i], rank: 0});
    }

    // Similarity Check. 70%
    // var wt = 0.7; var wt1 = 0.8 * wt; var wt2 = 0.2 * wt; // Number or Title: 80% (56%)
    const similarityCheckWeight = 1.0; //0.7;
    for(let i = 0; i < ranks.length; i++) {
      const numberRank = (this.compare(query, ranks[i].hymn.number)) * similarityCheckWeight;
      const titleRank  = (this.compare(normalizeQueryWithPunctuation(query), normalizeQueryWithPunctuation(ranks[i].hymn.name))) * similarityCheckWeight;
      ranks[i].rank += (numberRank > titleRank) ? numberRank : titleRank;
    }
    // Content: 20% (14%)
    // Not computed "on the fly" to save memory, should be indexed

    // Overall Popularity. 20%
    _.each(this.props.usageLogs, ([n, weight]) => {
			ranks[n - 1].rank += weight * 20 * 4;
    });

    // History. 10%
    // var str = getLocalStorageKey("history");
    // if(str) {
    //   var obj = JSON.parse(str)
    //   if(obj) {
    //     var list = obj[loaded_hymnal_id];
    //     if(list) {
    //       var occurences = {};
    //       for(var j = 0; j < list.length; j++) {
    //         if(!occurences[list[j]]) occurences[list[j]] = 0;
    //         occurences[list[j]]++;
    //       }
    //       var times = 0;
    //       for(var i = 0; i < ranks.length; i++) {
    //         if(times = occurences[ranks[i].hymn.number]) ranks[i].rank += f1(times);
    //       }
    //       // log(occurences)
    //     }
    //   }
    // }

    // Last Category. 10%
    // if(lastHymn && (lastHymn.category || lastHymn.subcategory)) {
    //   if(lastHymn.category)
    //     var similar = ranks.filter(function(elem) {return elem.hymn.category == lastHymn.category;})
    //   if(lastHymn.subcategory)
    //     var similar = ranks.filter(function(elem) {return elem.hymn.subcategory == lastHymn.subcategory;})
    //
    //   for(var entry of similar)
    //     entry.rank += 10;
    //   // log('similar');
    //   // log(similar.map(function(e) {return `${e.hymn.subcategory || e.hymn.category} ${e.hymn.number} ${e.hymn.name}`}));
    // } else {
    //   for(var entry in ranks)
    //     entry.rank += 10;
    // }

    ranks.sort((a, b) => b.rank - a.rank);

    const maxResults = 5;
    ranks = ranks.slice(0, maxResults);

    // log(ranks.filter(weakRanks).map(function(e) {return `${e.rank} ${e.hymn.name}`}));

    return ranks.filter(weakRanks(5));
  }

  compare(str1, str2) {
  var result = 0;

  var averageChars = (str1.length + str2.length) / 2;
  var averageWords = (str1.split(" ").length + str2.split(" ").length) / 2;

  // Exact Matching 40%
  var totalCharactersMatched = 0
  for(var g = 0; g < str1.length; g++) {
    if(str1[g] != str2[g]) break;
    totalCharactersMatched++;
  }
  result += (totalCharactersMatched / averageChars) * 0.4;

  // Word Matching 40%
  var totalWordsMatched = 0;
  var words1 = str1.split(" ").filter(clearemptystrings);
  var words2 = str2.split(" ").filter(clearemptystrings);
  for(var g = 0; g < words1.length; g++) {
    var indexOf = words2.indexOf(words1[g]);
    if(indexOf != -1) {
      words2.splice(indexOf, 1);
      totalWordsMatched++;
    }
  }
  result += (totalWordsMatched / averageWords) * 0.4;

  // Character Matching 20%
  var searcher = (str1.length > str2.length) ? str2 : str1;
  var searched = (str1.length > str2.length) ? str1 : str2;
  var longestLength = searched.length;
  totalCharactersMatched = 0;
  for(var g = 0; g < searcher.length; g++) {
    var indexOf = searched.indexOf(searcher[g]);
    if(indexOf != -1) {
      searched = searched.slice(indexOf + 1);
      totalCharactersMatched++;
    } else {break}
  }
  result += (totalCharactersMatched / longestLength) * 0.2;

  return result * 100;
}

  things() {

    function compareRanks(a, b) {
      return b.rank - a.rank;
    }

    function isC(elem) {
      return elem.hymn.category == category;
    }

    function isS(elem) {
      return elem.hymn.subcategory == subcategory;
    }

    function f1(x) { //computational function
      return Math.places((-8 / (x + (4/5))) + 10, 2)
    }

    function f2(x) { // takes a frequency number(0-10000's), returns weight(0-20).. adjust 0.02
      return Math.places((-8 / ((x * 0.02) + (4/5))) + 10, 2)
    }

  }

  render() { // TODO when hymnal changes, clear search query...

    let pageClass = 'app-page';
    if(!this.props.show) pageClass += ' hidden';

    return (

      <div id="search-page" className={pageClass}>
        <div className="page-content">
          <div className="page-header">
            <SearchBar onChange={q => this.updateSearchQuery(q)} placeholder={this.props.languageStrings.words.search} />
            <span className="right-title icon-tray">
                <CloseButton onClick={() => this.props.hidePage()} />
              </span>
          </div>
          <div className="page-bottom">

            <HymnListOld
              hymns={this.props.hymns}
              list={this.state.list}
              favorites={this.props.favorites}
              onClick={n => this.props.openHymn(n)}
              onFavorite={n => this.props.onFavorite(n)} />

          </div>
        </div>
      </div>

    );
  }

}

class HymnAppHymnPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      presentationMode: false,
      currentSlide: 0,
    };
    this.updateStoredHymnContent();
  }

  componentDidMount() {
    $(window).resize(()=>{
      if (this.state.presentationMode && this.flickityIsActive())
        this.resetFlickity();
        this.setState({currentSlide: 0});
    });
  }

  componentWillUnmount() {
    $(window).off('resize');
  }

  updateStoredHymnContent() {
    const parser = new HymnParser(this.props.hymns[this.props.hymn - 1], this.props.languageStrings);
    this.content = {
      fullText: parser.fullText(),
      slides: parser.pages(),
    }
  }

  componentDidUpdate(prevProps) {
    if(this.state.presentationMode && !this.flickityIsActive())
      this.initFlickity();
    else if (!this.state.presentationMode && this.flickityIsActive())
      this.deinitFlickity();
    if(this.props.hymn !== prevProps.hymn) {
      // this.carouselNode.flickity('remove');
      // this.carouselNode.flickity('reloadCells');
      // not ideal to set state in componentDidUpdate
      // causes unnecessary rerender
      if(this.flickityIsActive()) this.deinitFlickity();
      this.updateStoredHymnContent();
      this.setState({currentSlide: 0});
    }
  }

  selectSlide(index) {
    this.carouselNode.flickity('selectCell', index);
  }

  flickityIsActive() {
    return !!this.carouselNode.data('flickity')
  }

  resetFlickity() {
    this.deinitFlickity();
    this.initFlickity();
  }

  initFlickity() {
    this.carouselNode.flickity({
      pageDots: false,
    });
    this.carouselNode.on('change.flickity', (event, index) => {
      this.setState({currentSlide: index});
    });
    setTimeout(() => this.carouselNode.focus(), 500); // TODO replace with full-on keyboard support
    // (not this built in support)
  }

  deinitFlickity() {
    this.carouselNode.off('change.flickity');
    this.carouselNode.flickity('destroy');
  }

  startPresentation() {
    this.setState({
      presentationMode: true,
      currentSlide: 0,
    });
  }

  stopPresentation() {
    this.setState({presentationMode: false});
  }

  resetAndHidePage() {
    this.selectSlide(0);
    this.props.hidePage();
  }

  get carouselNode() {
    if(this._carouselNode) return this._carouselNode;
    return this._carouselNode = $('.main-carousel')
  }

  static renderCarouselCellContent(content, i) {
    return (
      <CenteredDiv key={i} className='carousel-cell'>
        {content}
      </CenteredDiv>
    );
  }

  static renderCarouselCellSplashContent(title, subtitle, i) {
    return (
      <CenteredDiv key={i} className='carousel-cell'>
        <span className='splash-title'>{title}</span>
        <span className='splash-subtitle'>{subtitle}</span>
      </CenteredDiv>
    );
  }

  render() {

    let pageClass = 'app-page';
    if(!this.props.show) pageClass += ' hidden';

    const hymn = this.props.hymns[this.props.hymn - 1] || {};
    const { fullText, slides } = this.content;

    const slideViews = [];
    const slideCharViews = [];
    _.each(slides, (page, i) => {
      if(page.lines){
        slideViews.push(HymnAppHymnPage.renderCarouselCellContent(page.lines.join('\n'), page.id));
      } else {
        slideViews.push(HymnAppHymnPage.renderCarouselCellSplashContent(page.title, page.subtitle, page.id));
      }
      const slideCharViewClasses = buildClassList('slide-char-view', {'active': i === this.state.currentSlide});
      slideCharViews.push(<span key={page.id} className={slideCharViewClasses} onClick={()=>this.selectSlide(i)}>{page.char}</span>)
    });
    const slide = slides[this.state.currentSlide];
    const slideTitle = this.state.currentSlide === 0 ? '' : slide.title;

    // hymn lyrics

    const classes = {
      listContent: buildClassList('page-content', {'display--none': this.state.presentationMode}),
      presentationContent: buildClassList('presentation-content', {'display--none': !this.state.presentationMode}),
    };

    return (
      <div id="hymn-page" className={pageClass}>
        <div className={classes.listContent}>
          <div className="page-header">
            <span className="title-bar">
              <span className="hymn-number">{hymn.number}</span>
              <span className="right-title icon-tray">
                <FavoriteButton active={this.props.favorites.indexOf(hymn.number) !== -1} onClick={() => this.props.onFavorite(hymn.number)} />
                <MaterialIcon code="slideshow" onClick={() => this.startPresentation()} />
                {/*<MaterialIcon code="share" />*/}
                <CloseButton onClick={() => this.props.hidePage()} />
              </span>
            </span>
            <span className="subtitle-bar">
              <span id="hymn-name">{hymn.name}</span>
            </span>
          </div>
          <hr/>
          <div className="page-bottom">
            <div className="hymn-lyrics width--full">
              {fullText}
            </div>
          </div>
        </div>
        <div className={classes.presentationContent}>
          <div className="page-header">
            <span className="title-bar">
              <span className="hymn-number long">{slideTitle}</span>
              <span className="right-title icon-tray">
                <MaterialIcon code="notes" onClick={() => this.stopPresentation()} />
                <CloseButton onClick={() => this.resetAndHidePage()} />
              </span>
            </span>
          </div>
          <div className="page-bottom hymn-lyrics main-carousel">
            {slideViews}
          </div>
          <div className="page-footer">
            {slideCharViews}
          </div>
        </div>
      </div>
    );
  }

}

class ListSort extends React.Component {

  render() {

    const translatedOptions = this.props.options.map(option => this.props.languageStrings.sortMethods[option]);
    const values = this.props.options.slice();

    // let options = [];
    // for(let option of this.props.options) {
    //   options.push(
    //     <option key={option}>{this.props.languageStrings.sortMethods[option]}</option>
    //   );
    // }
    // return (
    //   <span id="list-sort">
    //     {this.props.languageStrings.words.sort}: <select id="list-sort-select" onChange={e => this.props.onChange(e.target.value)} dir="rtl">
    //       {options}
    //     </select>
    //   </span>
    // );

    return (
      <span id="list-sort">
        {this.props.languageStrings.words.sort}: <VariableWidthSelect
          id="list-sort-select"
          onChange={e => this.props.onChange(e.target.value)}
          dir="rtl"
          options={translatedOptions}
          values={values} />

      </span>
    );
  }
}

class SearchBar extends React.Component {

  render() {
    return (
      <span id="search-bar">
        <input className="search-bar-input" type="text" onChange={e => this.props.onChange(e.target.value)} placeholder={this.props.placeholder} value={this.props.query} />
      </span>
    );
  }
}

export class CloseButton extends React.Component {
  render() {
    return <MaterialIcon code="close" className="clickable" onClick={() => this.props.onClick()} />;
  }
}

export class FavoriteButton extends React.Component {
  render() {
    const className = buildClassList('favorite', {'active': this.props.active});
    return <MaterialIcon code="favorite" className={className} onClick={e => {e.stopPropagation(); this.props.onClick()}} />;
  }
}

export class MaterialIcon extends React.Component {
  render() {
    const classList = buildClassList('material-icons', this.props.className || '');
    return (
      <i {...this.props} className={classList}>{this.props.code}</i>
    );
  }
}

class ThemeButton extends React.Component {

  render() {

    const imageSource = `./resources/images/${this.props.theme}-themeIcon.svg`;

    return (
      <div className='theme-button' onClick={() => this.props.onClick()}>
        <img src={imageSource} alt="Theme Button" />
      </div>
    );
  }

}


class VariableWidthSelect extends React.Component {

  constructor(props) {
    super(props);

    this.IDS = {
      mainSelectClassID: '_' + Math.round(Math.random()*10000),
      referenceSelect: 'ref_select__',
      referenceSelectOption: 'ref_select_option__',
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.updateWidth();
    }, 100)
  }

  optionChosen(event) {
    this.updateWidth();
    this.props.onChange(event);
  }

  updateWidth() {
    const selectNode = document.querySelector(`.${this.IDS.mainSelectClassID}`);
    const selectedOption = selectNode.querySelector(`:checked`);
    const referenceSelect = document.getElementById(this.IDS.referenceSelect);
    const referenceSelectOption = document.getElementById(this.IDS.referenceSelectOption);
    if(!referenceSelect || !referenceSelectOption) return;
    referenceSelectOption.innerHTML = selectedOption.innerHTML;
    selectNode.style.width = `${referenceSelect.offsetWidth}px`;
  }

  render() {

    let {
      id = '',
      className = '',
      onChange = () => {},
      dir = 'rtl',

      options = [],
      values,
    } = this.props;

    const optionTags = [];
    for(let i = 0; i < options.length; i++) {
      const option = options[i];
      const value = (typeof values[i] !== 'undefined') ? values[i] : option;
      optionTags.push(
        <option key={option} value={value}>{option}</option>
      );
    }

    return (
      <div>
        <select id={id} className={className + ' ' + this.IDS.mainSelectClassID} onChange={e => this.optionChosen(e)} dir={dir}>
          {optionTags}
        </select>
        <select id={this.IDS.referenceSelect} style={{position: 'fixed', top: '-100px'}}>
          <option id={this.IDS.referenceSelectOption}></option>
        </select>
      </div>
    );
  }
}


class Snackbar extends React.Component {

  render() {
    let className = 'snackbar';
    if(!this.props.showing) className = className + ' hidden';

    return (
      <div className={className}>
        <div className="left">{this.props.message}</div>
        <div className="right">
          <span className="link" onClick={() => this.props.linkAction()}>{this.props.linkMessage.toUpperCase()}</span>
        </div>
      </div>
    );
  }
}


const sdaLogoSvg = (
  <svg width="212px" height="194px" viewBox="0 0 212 194" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Home-w/-logo" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="375" transform="translate(-85.000000, -44.000000)" fill="#424242">
        <g id="White-SDA-Logo" transform="translate(85.000000, 44.000000)">
          <path d="M87.1764621,169.961021 L87.1764621,161.461603 L99,161.461603 L99,160.663638 C99,152.1569 95.1553166,145.922041 68.6540358,150.604896 L25.0753746,158.521092 L0,194 L60.1727646,183.11401 C78.2023441,179.958757 94.0332528,179.299887 99,193.919471 L99,169.961021 L87.1764621,169.961021" id="Fill-4"></path>
          <path d="M107,192.956436 C107,181.479766 113.689125,173.594698 127.34191,159.753476 L136.962599,150 L180.936074,157.851185 L206,193 L148.340318,182.914955 C128.790981,179.112793 112.218568,177.779254 107,192.956436" id="Fill-5"></path>
          <path d="M110,161 C114.405735,151.50274 123.784519,142.915179 129.177622,137.495797 L133.016043,133.578026 C149.345025,117.169477 152.485771,110.381908 153.475553,99.0798042 C153.519007,98.4903191 154.361528,101.294619 154.612595,103.278976 C155.455116,109.937974 154.967468,114.772723 152.715111,121.438999 C149.347439,131.404451 141.373662,139.344306 131.026824,149.741562 L119.774697,161 L110,161" id="Fill-6"></path>
          <path d="M119.730509,23.0862682 C119.730509,22.9967089 120,22.9482985 120,23.0862682 L120,36.1449758 C120,47.9522743 104.913302,61.5773837 98.9050904,67.5826949 L76.7995886,89.8805289 C69.1599926,97.5656812 53.8615513,112.747185 60.2836242,127.393754 C60.4977735,127.880279 60.6926735,128.299029 59.8769812,127.715683 C58.2407842,126.548993 55.7648333,122.448631 55.103136,114.959541 C53.9265179,101.60795 62.9761307,89.653 74.1359562,78.4242058 L95.2212411,57.1889802 C116.602485,35.6778153 118.688636,31.8872804 119.730509,23.0862682" id="Fill-7"></path>
          <g id="Group-11" transform="translate(52.000000, 0.000000)">
            <path d="M46.7866196,90.6007253 C52.782626,84.5505823 67.8386774,70.8237564 67.8386774,58.9258734 L67.8386774,45.7696777 C67.8386774,45.6331167 67.5697335,45.6818885 67.5697335,45.7696777 C66.5299775,54.6388313 64.4480642,58.457664 43.1102536,80.1294177 L23.563801,100.011246 C16.4632039,107.222158 9.95092135,114.781789 10.2510819,126.989373 C10.4359807,134.46853 14.1387608,140.667427 19.70974,142.128142 C22.0029663,142.630492 21.8636918,142.325668 21.3186003,142.091563 C13.447191,138.319064 14.0138941,123.885047 26.7358973,110.965394 L46.7866196,90.6007253" id="Fill-8"></path>
            <path d="M22.2502986,70.7018269 C6.00561156,87.196453 2.88394222,94.0196291 1.89701445,105.381022 C1.85379133,105.9736 1.01574318,103.154589 0.766009631,101.159822 C-0.0720385233,94.4658912 0.413020867,89.6057804 2.65341894,82.9045337 C6.00321027,72.886804 13.9346517,64.9052973 24.2265554,54.4559371 L43.1102536,35.2471598 C64.4480642,13.5754061 66.5299775,9.75657338 67.5697335,0.887419774 C67.5697335,0.799630517 67.8386774,0.750858707 67.8386774,0.887419774 L67.8386774,14.0436155 C67.8386774,25.9414985 52.782626,39.6683243 46.7866196,45.7184673 L22.2502986,70.7018269" id="Fill-10"></path>
          </g>
          <path d="M107.258352,182.924971 C107.247216,183.023801 107,183.026211 107,182.924971 L107,170 L112,170 C109.173719,174.382245 107.730512,178.624682 107.258352,182.924971" id="Fill-12"></path>
          <path d="M107.272543,161.922188 C107.263063,162.024713 107,162.027154 107,161.922188 L107,148.601225 C107,138.592806 116.524793,127.771507 125.964268,118.112161 L132.088195,111.806857 C137.029522,106.717209 152.123676,91.3823575 145.795934,76.6113946 C145.587379,76.1207379 145.393044,75.6984315 146.198824,76.2867313 C147.808014,77.4633308 150.249053,81.5985169 150.898417,89.1536533 C152.057318,102.616198 143.14397,114.672683 132.152184,125.996843 L126.490395,131.85543 C112.839535,145.91604 108.298728,152.216462 107.272543,161.922188" id="Fill-13"></path>
          <path d="M107.273735,137.924622 C107.261834,138.023912 107,138.026333 107,137.924622 L107,124.505924 C107,115.039458 116.228442,104.822261 120.708176,100.264602 L127.651525,93.2150029 C140.26,80.3847809 140.821752,66.0530984 133.019113,62.3067123 C132.478783,62.0718064 132.340726,61.7715143 134.613917,62.2703866 C140.138605,63.7209912 143.809035,69.8769792 143.989938,77.3043652 C144.287476,89.4250261 137.941583,96.8838943 130.903022,104.047314 L125.273601,109.772237 C113.498232,121.750017 108.344872,128.753604 107.273735,137.924622" id="Fill-14"></path>
          <path d="M206.307692,171.807692 L206.776442,171.807692 C207.509615,171.807692 207.879808,171.454327 207.879808,170.740385 C207.879808,170.377404 207.740385,170.076923 207.466346,169.834135 C207.192308,169.591346 206.855769,169.46875 206.451923,169.46875 C206.194712,169.46875 206.067308,169.569712 206.067308,169.774038 L206.076923,169.913462 L206.076923,171.572115 C206.076923,171.682692 206.084135,171.75 206.108173,171.771635 C206.132212,171.795673 206.197115,171.807692 206.307692,171.807692 L206.307692,171.807692 Z M207.629808,171.987981 L208.745192,173.617788 L208.884615,173.814904 C209.233173,174.324519 209.548077,174.584135 209.826923,174.598558 L209.959135,174.605769 C210.048077,174.610577 210.088942,174.651442 210.086538,174.730769 C210.076923,174.867788 209.855769,174.935096 209.427885,174.935096 C208.935096,174.935096 208.490385,174.637019 208.096154,174.045673 L207.052885,172.473558 L206.995192,172.379808 C206.939904,172.286058 206.846154,172.240385 206.716346,172.240385 L206.158654,172.240385 L206.09375,172.247596 L206.076923,172.331731 L206.076923,173.786058 C206.076923,174.110577 206.117788,174.322115 206.204327,174.425481 C206.290865,174.524038 206.487981,174.591346 206.793269,174.625 C206.930288,174.639423 207,174.6875 207.004808,174.776442 C207.009615,174.872596 206.944712,174.915865 206.805288,174.915865 C206.764423,174.915865 206.680288,174.908654 206.550481,174.894231 C206.442308,174.879808 206.266827,174.875 206.019231,174.875 L205.389423,174.875 C205.310096,174.875 205.192308,174.882212 205.043269,174.901442 C204.935096,174.911058 204.865385,174.915865 204.831731,174.915865 C204.709135,174.915865 204.649038,174.867788 204.649038,174.774038 C204.649038,174.704327 204.699519,174.658654 204.802885,174.634615 C205.019231,174.581731 205.158654,174.487981 205.216346,174.350962 C205.276442,174.211538 205.305288,173.913462 205.305288,173.454327 L205.305288,170.490385 L205.295673,170.064904 C205.295673,169.665865 205.158654,169.447115 204.879808,169.403846 L204.680288,169.375 C204.560096,169.353365 204.497596,169.298077 204.497596,169.213942 C204.497596,169.122596 204.564904,169.074519 204.692308,169.074519 C204.725962,169.074519 204.826923,169.081731 204.992788,169.096154 C205.081731,169.100962 205.206731,169.103365 205.365385,169.103365 C205.495192,169.103365 205.711538,169.09375 206.014423,169.074519 C206.245192,169.064904 206.442308,169.057692 206.610577,169.057692 C207.949519,169.057692 208.620192,169.548077 208.620192,170.533654 C208.620192,171.153846 208.288462,171.637019 207.629808,171.987981 L207.629808,171.987981 Z M207,167.555288 C205.774038,167.555288 204.723558,167.987981 203.855769,168.858173 C202.985577,169.728365 202.555288,170.776442 202.555288,172.004808 C202.555288,173.233173 202.985577,174.28125 203.855769,175.153846 C204.723558,176.021635 205.774038,176.456731 207,176.456731 C208.225962,176.456731 209.274038,176.021635 210.141827,175.153846 C211.009615,174.28125 211.447115,173.233173 211.447115,172.004808 C211.447115,170.771635 211.012019,169.721154 210.146635,168.855769 C209.28125,167.987981 208.230769,167.555288 207,167.555288 L207,167.555288 Z M207,167 C208.384615,167 209.564904,167.485577 210.538462,168.463942 C211.512019,169.4375 212,170.617788 212,172.002404 C212,173.384615 211.512019,174.564904 210.536058,175.538462 C209.560096,176.514423 208.382212,177 207,177 C205.451923,177 204.182692,176.413462 203.197115,175.237981 C202.399038,174.288462 202,173.211538 202,172.002404 C202,170.771635 202.394231,169.689904 203.1875,168.754808 C204.1875,167.584135 205.461538,167 207,167 L207,167 Z" id="Fill-15"></path>
        </g>
      </g>
    </g>
  </svg>
);
